import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Sortable wrappers for the size/measure grid.
// Used by both the New-Table Wizard (step 3) and the Edit-Table drawer so
// the merchant can drag-reorder sizes (rows) and measures (columns) without
// losing filled cm values (the grid keys are remapped via `remapValuesAfterReorder`).

/** Wraps a single grid row (a size) so it can be drag-reordered. */
export const SortableGridRow = ({ id, children, style: extraStyle, className = "" }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
        zIndex: isDragging ? 10 : "auto",
        position: "relative",
        ...extraStyle,
    };
    return (
        <div ref={setNodeRef} style={style} className={className} data-dragging={isDragging || undefined}>
            {typeof children === "function" ? children({ attributes, listeners }) : children}
        </div>
    );
};

/** Wraps the header cell of a measure so the entire column can be drag-reordered. */
export const SortableColHeader = ({ id, children, className = "" }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
    };
    return (
        <div ref={setNodeRef} style={style} className={className} data-dragging={isDragging || undefined}>
            {typeof children === "function" ? children({ attributes, listeners }) : children}
        </div>
    );
};
